import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import FraudTable from "./FraudTable";

const FraudView = () => {

  const { loading, error, data } = useQuery(FRAUD_USERS_QUERY);

  if (loading) {
    console.log("Loading");
    // return 'Loading...';
  }
  if (error) {
    console.log("Fraud - error:", error.message);
    // return `Error! ${error.message}`;
  }

  return error ? (
    <>Error...</>
  ) : loading ? (
    <>Loading...</>
  ) : (
    <div className="fraud-list">
      <FraudTable fraudsters={data.users} />
    </div>
  );
};



const FRAUD_USERS_QUERY = gql`
  query FraudUsers {
    users(type: "fraud") {
      id
      email
      first_name
      last_name
      application_status
      created_at
      approved_at
      credit {
        credit_limit
      }
      total_spend
      tags
      metadata
    }
  }
`;

export default FraudView;
